export const COLORS = {
  pink: '#ff1f8f',
  purple: '#9d28ac',
  cyan: '#00e5ff',
  darkBg: '#1a1a1a',
  darkBgAlt: '#2a2a2a',
  white: '#ffffff',
  whiteTransparent: 'rgba(255, 255, 255, 0.8)',
  whiteSubtle: 'rgba(255, 255, 255, 0.1)',
  error: '#ff4444',
  warning: '#ffc107',
  gradientPrimary: 'linear-gradient(135deg, #ff1f8f 0%, #9d28ac 100%)',
  gradientButton: 'linear-gradient(135deg, #ff1f8f 0%, #9000ff 100%)',
  gradientBg: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)',
  blue: '#0066cc',
  jsonGreen: '#4CAF50',
  csvBlue: '#2196F3',
  pdfRed: '#F44336'
};

export const BREAKPOINTS = {
  mobile: '768px',
  tablet: '968px',
  desktop: '1200px'
};

export const MAX_WIDTH = '1200px';
